import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil, finalize } from 'rxjs';
import { AppConfigService } from '../../../services/app-config.service';
import { RewardsTabV1Component } from './rewards-tab-v1.component';
import { RewardsTabV2Component } from './rewards-tab-v2.component';

@Component({
  selector: 'app-rewards-tab',
  standalone: true,
  imports: [CommonModule, RewardsTabV1Component, RewardsTabV2Component],
  templateUrl: './rewards-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./rewards-tab.component.scss'],
})
export class RewardsTabComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  isConfigLoading = true;
  rewardsV2Enabled = false;

  constructor(private readonly appConfigService: AppConfigService) {}

  ngOnInit(): void {
    this.loadAppConfig();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadAppConfig(): void {
    this.appConfigService
      .getAppConfig()
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isConfigLoading = false;
        })
      )
      .subscribe({
        next: config => {
          this.rewardsV2Enabled = config.rewardsV2Enabled === true;
        },
        error: () => {
          this.rewardsV2Enabled = false;
        },
      });
  }
}
